import { sanitizeInput, SanitizePatterns } from './sanitizeInput'

/**
 * Create a sanitized handler for single field forms
 */
export const createSanitizedHandler = (
  setState: React.Dispatch<React.SetStateAction<string>>,
  pattern: keyof typeof SanitizePatterns = 'text'
) => {
  return (e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitizedValue = SanitizePatterns[pattern](e.target.value)
    setState(sanitizedValue)
  }
}

/**
 * Create a sanitized handler for forms with multiple fields in a single state object
 */
export const createSanitizedObjectHandler = (
  setState: React.Dispatch<React.SetStateAction<any>>,
  fieldPatterns: Record<string, keyof typeof SanitizePatterns> = {}
) => {
  return (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    const pattern = fieldPatterns[name] || 'text'
    const sanitizedValue = SanitizePatterns[pattern](value)

    setState((prevState: any) => ({
      ...prevState,
      [name]: sanitizedValue,
    }))
  }
}

/**
 * Alternative: Create individual sanitized handlers for each field
 */
export const createFieldSanitizedHandler = (
  setState: React.Dispatch<React.SetStateAction<any>>,
  fieldName: string,
  pattern: keyof typeof SanitizePatterns = 'text'
) => {
  return (e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitizedValue = SanitizePatterns[pattern](e.target.value)

    setState((prevState: any) => ({
      ...prevState,
      [fieldName]: sanitizedValue,
    }))
  }
}
